import React from 'react';

import _ from 'lodash';

import VendorRequestStatusLabel from '../VendorRequestStatusLabel';

import { formatDuration, formatRequestDate } from './VendorRequestDetailDrawer.utils';

const getField = field => request => _.get(request, field);
const getDate = field => request => formatRequestDate(_.get(request, field));

export const metaGridConfig = [
  { id: 'requestType', label: 'Request Type', getValue: getField('requestType') },
  { id: 'operationType', label: 'Operation Type', getValue: getField('operationType') },
  { id: 'vendorName', label: 'Vendor', getValue: getField('vendorName') },
  { id: 'executionType', label: 'Execution', getValue: getField('executionType') },
  {
    id: 'status',
    label: 'Status',
    getValue: request =>
      _.get(request, 'status') ? (
        <VendorRequestStatusLabel status={_.get(request, 'status')} />
      ) : null,
  },
  {
    id: 'httpStatusCode',
    label: 'HTTP Status',
    getValue: getField('connectionMetadata.HttpStatusCode'),
  },
  { id: 'createdAt', label: 'Created', getValue: getDate('createdAt') },
  { id: 'requestedAt', label: 'Requested', getValue: getDate('requestedAt') },
  { id: 'completedAt', label: 'Completed', getValue: getDate('completedAt') },
  { id: 'failedAt', label: 'Failed', getValue: getDate('failedAt') },
  {
    id: 'duration',
    label: 'Duration',
    getValue: request =>
      formatDuration(
        _.get(request, 'requestedAt'),
        _.get(request, 'completedAt') ?? _.get(request, 'failedAt'),
      ),
  },
  { id: 'vendorRequestId', label: 'Vendor Request ID', getValue: getField('vendorRequestId') },
  { id: 'correlationId', label: 'Correlation ID', getValue: getField('correlationId') },
  { id: 'operationId', label: 'Operation ID', getValue: getField('operationId') },
];
